import { StyledToggleGroup, StyledToggleGroupContainer, StyledToggleGroupLabel } from "components/controls/ToggleGroup/styled/toggle-group.styled";
import { useForm } from "modules/forms";
import { ObservationConcernLevelEnum } from "shared/enums/ObservationConcernLevel.enum";
import { NearMissEntity } from "shared/types/domain/NearMissEntity";
import { highConcernLevelTooltip, lowConcernLevelTooltip, mediumConcernLevelTooltip } from "../constants/concern-level-toggle.constants";
import ConcernLevelButton from "./ConcernLevelButton/ConcernLevelButton";
import { useTranslation } from 'react-i18next';

interface ConcernLevelToggleProps {
    readOnly: boolean;
    label: string;

    useEnglish?: boolean;
}

export const ConcernLevelToggle = ({
    readOnly,
    label,
    useEnglish
}: ConcernLevelToggleProps) => {

    const { formData, updateFields } = useForm<NearMissEntity>();
    const { t } = useTranslation();

    return (
        <StyledToggleGroupContainer>
            <StyledToggleGroupLabel showRequired>
                {label}
            </StyledToggleGroupLabel>
            <StyledToggleGroup>
                <ConcernLevelButton
                    forConcernLevel={ObservationConcernLevelEnum.Low}
                    text={useEnglish ? "Low" : t('ObservationPage.Low')}
                    tooltip={useEnglish ? "Low = Continue and report" : t(lowConcernLevelTooltip)}
                    value={formData?.concernLevel}
                    disabled={readOnly}
                    onClick={e => updateFields({
                        concernLevel: { runValidation: false, value: ObservationConcernLevelEnum.Low }
                    })}
                />
                <ConcernLevelButton
                    forConcernLevel={ObservationConcernLevelEnum.Medium}
                    text={useEnglish ? "Medium" : t('ObservationPage.Medium')}
                    tooltip={useEnglish ? "Medium = Use caution and report" : t(mediumConcernLevelTooltip)}
                    value={formData?.concernLevel}
                    disabled={readOnly}
                    onClick={e => updateFields({
                        concernLevel: { runValidation: false, value: ObservationConcernLevelEnum.Medium }
                    })}
                />
                <ConcernLevelButton
                    forConcernLevel={ObservationConcernLevelEnum.High}
                    text={useEnglish ? "High" : t('ObservationPage.High')}
                    tooltip={useEnglish ? "High = Stop work then report" : t(highConcernLevelTooltip)}
                    value={formData?.concernLevel}
                    disabled={readOnly}
                    onClick={e => updateFields({
                        concernLevel: { runValidation: false, value: ObservationConcernLevelEnum.High }
                    })}
                />
            </StyledToggleGroup>
        </StyledToggleGroupContainer>
    );
}